import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { cn } from '@/lib/utils';
import { ChatMessage } from '@/hooks/useChat';
import { useAuth } from '@/contexts/AuthContext';
import { Check, CheckCheck } from 'lucide-react';

interface ChatMessageBubbleProps {
  message: ChatMessage;
}

export function ChatMessageBubble({ message }: ChatMessageBubbleProps) {
  const { user } = useAuth();
  const isOwn = message.sender_id === user?.id;

  return (
    <div className={cn('flex', isOwn ? 'justify-end' : 'justify-start')}>
      <div
        className={cn(
          'max-w-[80%] rounded-2xl px-4 py-2',
          isOwn
            ? 'bg-primary text-primary-foreground rounded-br-md'
            : 'bg-muted rounded-bl-md'
        )}
      >
        {!isOwn && message.sender && (
          <p className="text-xs font-medium mb-1 opacity-70">
            {message.sender.name}
          </p>
        )}
        <p className="text-sm whitespace-pre-wrap break-words">{message.content}</p>
        <div className={cn(
          'flex items-center gap-1 mt-1',
          isOwn ? 'justify-end' : 'justify-start'
        )}>
          <span className="text-[10px] opacity-60">
            {format(new Date(message.created_at), 'HH:mm', { locale: fr })}
          </span>
          {isOwn && (
            message.read_at ? (
              <CheckCheck className="h-3 w-3 opacity-60" />
            ) : (
              <Check className="h-3 w-3 opacity-60" />
            )
          )}
        </div>
      </div>
    </div>
  );
}
